/* ============================================================
   KOLDRAY — Offer selector + sticky price bar (vanilla, no deps)
   Works with Dawn's <product-form>. Selecting a tier sets the
   hidden variant id; the sticky bar mirrors price + CTA.
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function initOffer(root) {
    var tiers = Array.prototype.slice.call(root.querySelectorAll('.kld-tier'));
    var idInput = root.querySelector('input[name="id"]');
    var btnPrice = root.querySelector('[data-kld-btn-price]');
    var form = root.querySelector('form');
    var upsell = root.querySelector('[data-kld-upsell]');

    function selectedTier() {
      return root.querySelector('.kld-tier[data-selected="true"]') || tiers[0];
    }

    function syncPrice() {
      var t = selectedTier();
      if (!t) return;
      var now = parseInt(t.getAttribute('data-price'), 10) || 0;
      var was = parseInt(t.getAttribute('data-compare'), 10) || 0;
      // main button
      if (btnPrice) btnPrice.textContent = money(now);
      // sticky bar
      var s = document.querySelector('.kld-sticky');
      if (s) {
        var sn = s.querySelector('.now'), sw = s.querySelector('.was'), st = s.querySelector('[data-kld-sticky-name]');
        if (sn) sn.textContent = money(now);
        if (sw) { sw.textContent = was > now ? money(was) : ''; }
        if (st) st.textContent = t.getAttribute('data-name') || '';
      }
    }

    function pick(t) {
      tiers.forEach(function (x) { x.setAttribute('data-selected', x === t ? 'true' : 'false'); var r = x.querySelector('input[type=radio]'); if (r) r.checked = (x === t); });
      syncPrice();
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(t); } });
      t.setAttribute('tabindex', '0');
    });

    // ensure hero pre-selected on load
    var initial = root.querySelector('.kld-tier[data-selected="true"]') || tiers[0];
    if (initial) pick(initial);

    // Full AJAX submit: add selected tier (+ upsell if checked), then go to cart.
    // No-JS fallback: native form POST still adds the selected variant.
    if (form) {
      form.addEventListener('submit', function (e) {
        var t = selectedTier();
        var mainId = t ? t.getAttribute('data-variant') : (idInput && idInput.value);
        if (!mainId) return; // let native submit try
        e.preventDefault();
        var items = [{ id: parseInt(mainId, 10), quantity: 1 }];
        if (upsell && upsell.checked && upsell.getAttribute('data-variant')) {
          items.push({ id: parseInt(upsell.getAttribute('data-variant'), 10), quantity: 1 });
        }
        var addUrl = (window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js';
        var cartUrl = (window.routes && routes.cart_url ? routes.cart_url : '/cart');
        var btn = form.querySelector('[name="add"]');
        if (btn) { btn.setAttribute('disabled', 'disabled'); btn.style.opacity = '.7'; }
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = cartUrl; })
          .catch(function () { form.submit(); }); // hard fallback to native
      });
    }
  }

  function initSticky() {
    var bar = document.querySelector('.kld-sticky');
    if (!bar) return;
    var anchor = document.querySelector('[data-kld-sticky-anchor]') || document.querySelector('.kld-offer');
    var footer = document.querySelector('.footer') || document.querySelector('footer');

    function update() {
      var showAfter = anchor ? anchor.getBoundingClientRect().bottom < 0 : (window.scrollY > 700);
      var nearFooter = false;
      if (footer) {
        var fr = footer.getBoundingClientRect();
        nearFooter = fr.top < window.innerHeight - 40;
      }
      if (showAfter && !nearFooter) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // sticky CTA scrolls to offer only if it's an anchor; otherwise navigate normally
    var sbtn = bar.querySelector('[data-kld-sticky-cta]');
    if (sbtn) sbtn.addEventListener('click', function (e) {
      var href = sbtn.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        var target = document.querySelector('.kld-offer') || document.querySelector(href);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-kld-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        var main = document.querySelector('[data-kld-gallery-main] img');
        if (full && main) { main.src = full; main.srcset = ''; }
        document.querySelectorAll('[data-kld-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    // Cibles d'animation + stagger par parent
    var sel = '.kld-sec__head, .kld-pain, .kld-step, .kld-benefit, .kld-review, .kld-tier, .kld-guarantee, .kld-demo__grid > *, .kld-pdp__buy, .kld-pdp__media, .kld-incl, .kld-spec, .kld-stat';
    var groups = {};
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.kld-pdp__media') && el.classList.contains('kld-pdp__media') === false) return;
      el.setAttribute('data-reveal', '');
      var p = el.parentElement;
      var key = p ? (p.dataset._g || (p.dataset._g = Math.random().toString(36).slice(2))) : 'x';
      groups[key] = (groups[key] || 0);
      el.style.setProperty('--d', (groups[key] * 90) + 'ms');
      groups[key]++;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });

    // Q-Max : déclenche le remplissage des barres
    document.querySelectorAll('.kld-qmax').forEach(function (q) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io2.unobserve(e.target); } });
      }, { threshold: 0.25 });
      io2.observe(q);
    });
  }

  function initFrost() {
    document.querySelectorAll('.kld-frost').forEach(function (box) {
      var n = 16;
      for (var k = 0; k < n; k++) {
        var i = document.createElement('i');
        i.textContent = '❄';
        i.style.left = Math.random() * 100 + '%';
        i.style.fontSize = (8 + Math.random() * 14) + 'px';
        i.style.animationDuration = (7 + Math.random() * 9) + 's';
        i.style.animationDelay = (-Math.random() * 12) + 's';
        box.appendChild(i);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-kld-offer]').forEach(initOffer);
    initSticky();
    initGallery();
    initReveal();
    initFrost();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
